import React, { useEffect, useState } from 'react'
import Loader from '../../../component/loader/Loader'
import DataTable from '../../../component/data-table/DataTable'
import { useDispatch, useSelector } from 'react-redux'
import { CustomerReviewListRes, CustomerReviewListTodo } from '../../../redux/slices/user managment/customer/CustomerReviewList'

export default function CustomerReviewList(props) {
    const { customerDetail } = props
    const dispatch = useDispatch()
    const [loading, setLoading] = useState(false)
    const CustomerReview = useSelector(state => state?.CustomerReviewList?.data?.data)

    useEffect(() => {
        setLoading(true)
        dispatch(CustomerReviewListTodo(customerDetail?.id)).then(() => list_res())
    }, [])

    const list_res = () => {
        if (CustomerReviewListRes?.success) {
            setLoading(false)
        } else {
            setLoading(false)
        }
    }
const columnDefs = [
        {
            headerName: 'S.NO',
            // valueGetter: 'node.rowIndex + 1',
            cellRenderer: params => params.node.rowIndex + 1,
            filter: 'false',
            suppressMenu: true,
            sortable: true,
            floatingFilter: false,
            // wrapText: true,
            // autoHeight: true,
            maxWidth: 80
        },
        // {
        //     headerName: 'CUSTOMER',
        //     field: 'CustomerDetailsSchema.customer_name',
        //     filter: 'agTextColumnFilter',
        //     suppressMenu: true,
        //     filter: true,
        //     sortable: true,
        //     floatingFilter: false,
        //     // wrapText: true,
        //     // autoHeight: true,
        // },
        {
            headerName: 'VENDOR',
            field: 'VendorDetailsSchema.vendor_name',
            filter: 'agTextColumnFilter',
            suppressMenu: true,
            filter: true,
            sortable: true,
            floatingFilter: false,
             maxWidth:200,
            // wrapText: true,
            // autoHeight: true,
        },
        {
            headerName: 'RATING',
            field: 'feedback_range',
            filter: 'agTextColumnFilter',
            suppressMenu: true,
            filter: true,
            sortable: true,
            floatingFilter: false,
            maxWidth:120,
            // wrapText: true,
            // autoHeight: true,
        },
       
        {
            headerName: 'REMARK',
            field: 'remarks',
            filter: 'agTextColumnFilter',
            suppressMenu: true,
            filter: true,
            sortable: true,
            floatingFilter: false,
            // wrapText: true,
            // autoHeight: true,

        },
        
       
    ]
    return (
        <>
            {loading ?
                <diV className='dd-flex justify-content-center mt-5 pt-5'>
                    <Loader />
                </diV> :
                CustomerReviewList && CustomerReviewList.length ?

                    <div className='mt-1'>
                        <DataTable
                            rowData={CustomerReview}
                            columnDefs={columnDefs}
                            height={'55vh'}
                        />
                    </div> : <div className='empty_section mt-3'>
                        <span>DATA NOT FOUND</span>
                    </div>}
        </>
    )
}
